// specific styles for smaller inputs / autocompleteDropdowns
export const smallerInputsAndDropdowns = {
  "& .MuiFormControl-root": {
    "& > .MuiInputLabel-outlined": {
      transform: "translate(14px, 10px) scale(1)",
    },

    "& > .MuiInputLabel-outlined.Mui-focused, & > .MuiInputLabel-outlined.MuiFormLabel-filled": {
      transform: "translate(14px, -6px) scale(0.75)",
    },

    "& > .MuiInputBase-root > input": {
      padding: "10px 14px 8px",
    },

    "& > .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      padding: "0 0 0 10px",
    },

    "& .MuiCircularProgress-root": {
      marginRight: "30px",
    },
  },
};
